import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/store';
import {
  toggleMenuItem,
  expandMenuItem,
  collapseMenuItem,
  collapseAllItems,
  selectExpandedItems,
} from '../menuSlice';
import { useGetMenuItemsQuery } from '../api/menuApi';

export const useMenu = (siteId?: number) => {
  const dispatch = useAppDispatch();

  const {
    data: menuItems = [],
    isLoading: loading,
    error: queryError,
    refetch,
  } = useGetMenuItemsQuery(siteId);

  const expandedItems = useAppSelector(selectExpandedItems);

  const error = queryError
    ? 'status' in queryError
      ? 'error' in queryError
        ? String(queryError.error)
        : `Error: ${queryError.status}`
      : 'message' in queryError
        ? queryError.message
        : 'Failed to load menu'
    : null;

  const loadMenu = useCallback(() => {
    refetch();
  }, [refetch]);

  const toggle = useCallback(
    (itemId: number) => {
      dispatch(toggleMenuItem(itemId));
    },
    [dispatch]
  );

  const expand = useCallback(
    (itemId: number) => {
      dispatch(expandMenuItem(itemId));
    },
    [dispatch]
  );

  const collapse = useCallback(
    (itemId: number) => {
      dispatch(collapseMenuItem(itemId));
    },
    [dispatch]
  );

  const collapseAll = useCallback(() => {
    dispatch(collapseAllItems());
  }, [dispatch]);

  const clearError = useCallback(() => {}, []);

  const isExpanded = useCallback(
    (itemId: number) => {
      return expandedItems.includes(itemId);
    },
    [expandedItems]
  );

  return {
    menuItems,
    loading,
    error,
    expandedItems,
    siteId,
    loadMenu,
    toggle,
    expand,
    collapse,
    collapseAll,
    clearError,
    isExpanded,
  };
};

export default useMenu;
